import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles({
  Container: {
    marginLeft: '25px',
  },
  Field: {
    display: 'grid',
    paddingRight: '10px',
    width: '100%',
  },
  Bold: {
    fontWeight: 'bold',
  },
  UpperCase: {
    textTransform: 'uppercase',
  },
  FilterPositionsRow: {
    padding: '10px',
  },
  PositionTemplateGroupName: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    color: '#000',
  },
  PositionTemplateSelect: {
    fontSize: '14px',
  },
  ApplyAllWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ApplyAllButtonWrapper: {
    marginRight: '10px',
    justifyContent: 'flex-end',
  },
  ApplyAllDropdown: {
    width: 'calc(100% - 150px)',
  },
  ApplyAllButton: {
    height: '40px',
    width: '90px',
    marginLeft: '10px',
    marginRight: '10px',
  },
  iconWrapper: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '40px',
    width: '40px',
    fontSize: '20px',
    color: '#0070BE',
  },
  applyToAllLabel: {
    marginLeft: '40px',
  },
});
